import { Helper } from '../../Helper';
export class OmitObjectPropertiesHelper extends Helper {
    emit(sb, node, options) {
        sb.emitOp(node, 'ROT');
        sb.emitOp(node, 'TUCK');
        sb.emitOp(node, 'SWAP');
        sb.emitHelper(node, options, sb.helpers.omitPropertyObjectProperties);
        sb.emitOp(node, 'SWAP');
        sb.emitHelper(node, options, sb.helpers.omitSymbolObjectProperties);
    }
}

//# sourceMappingURL=OmitObjectPropertiesHelper.js.map
